import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deliveryInfo: {
    id: 'pd.delivery.info',
    defaultMessage: 'Způsoby dopravy',
  },
  deliveryDrawerTitle: {
    id: 'pd.delivery.drawer.title',
    defaultMessage: 'Možnosti doručení',
  },
  deliveryDrawerTabHome: {
    id: 'pd.delivery.drawer.tab.home',
    defaultMessage: 'Na adresu',
  },
  deliveryDrawerTabPersonal: {
    id: 'pd.delivery.drawer.tab.personal',
    defaultMessage: 'Osobní odběr',
  },
  deliveryOrderBefore: {
    id: 'pd.delivery.orderBefore',
    defaultMessage: 'Objednejte do {time}',
  },
  deliveryIfYouOrderBefore: {
    id: 'pd.delivery.ifYouOrderBefore',
    defaultMessage: 'pokud objednáte do {time}',
  },
});
